import {
	Box,
	Divider,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Tooltip,
	Typography,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment-timezone';
import { AppColors } from '../../../Utils/helper/AppColors';
import { InfoIcon, EarthIcon, IosLink } from '../../../Components/Icons/Icons';
import { getFilteredAndSortedUsers, getReportCallDetails } from '../../../Utils/helper/commonUtils';
import CustomTablePagination from '../../../Components/CustomTablePagination';
import UserThumbnail from '../../../Components/User/UserThumbnail';
import CustomTag from '../../../Components/CustomTag';
import DataNotFound from '../../../Components/DataNotFound.js';
import CustomInfoTooltip from '../../../Components/CustomInfoTooltip.js';
import { theme } from 'antd';
import { useDispatch } from 'react-redux';
import { setReportsCallDetails } from '../../../store/reducers/appActions.js';
import { formatDuration } from '../../../Utils/helper/commonUtils.js';

export default function CampaignDetailsReports({ filteredUsers, search, setCanShowReportSummary, selectedType , getList , pagination }) {
	const dispatch = useDispatch();
	// const [pagination, setPagination] = useState({ count: 0, rowsPerPage: 10, page: 1 });

	// const filteredAndPaginatedUsers = useMemo(
	// 	() => getFilteredAndSortedUsers(details, search, pagination, setPagination, selectedType),
	// 	[details, search, pagination?.rowsPerPage, pagination?.page, selectedType], // Recompute only when `details` or `search` changes
	// );

	// const getAllReportCallDetails = useMemo(() => getReportCallDetails(details), []);

	// useEffect(() => {
	// 	if (!getAllReportCallDetails) return;
	// 	console.log('getAllReportCallDetails inside effect', getAllReportCallDetails);
	// 	setCanShowReportSummary?.(getAllReportCallDetails); // tell parent to render it
	// }, [getAllReportCallDetails]);

	// console.log('filteredAndPaginatedUsers', filteredAndPaginatedUsers);
	// const getListDuplicate = async (page = 1, limit = pagination?.rowsPerPage) => {
	// 	setPagination({
	// 		...pagination,
	// 		page: page,
	// 		rowsPerPage: limit,
	// 	});
	// };

	// console.log("Filtered Users: 2", filteredUsers);

	const HistoryItem = ({ history, details }) => (
		<Stack direction="row" gap={1} alignItems="start">
			<Typography
				sx={{ fontSize: '12px', lineHeight: '115%', fontFamily: 'Poppins', color: AppColors.TEXT_PRIMARY, fontWeight: 400 }}
				flexShrink={0}
				fontSize={12}
			>
				{history?.callTime && details?.userId?.timezone && moment(history?.callTime).tz(details?.userId?.timezone).format('lll')}{' '}
			</Typography>
			{/* <Typography>-</Typography> */}
			<Typography  fontSize={12} textTransform={'capitalize'} sx={{lineHeight:'16px'}}>
				- {history?.endedReason?.replaceAll('-', ' ')}
			</Typography>
		</Stack>
	);

	return (
		<TableContainer
			sx={(theme) => ({
				height: 'calc(100vh - 200px)',
				overflow: 'scroll',
				borderRadius: '0 0 12px 12px',
				borderColor: theme.palette.primary.lightest_shade,
				backgroundColor: AppColors.WHITE,
			})}
		>
			{filteredUsers?.length === 0 ? (
				<DataNotFound />
			) : (
				<Table stickyHeader>
					<TableHead
						sx={{
							'& .MuiTableCell-root': {
								fontSize: 14,
								color: AppColors.BLACK,
								fontWeight: 600,
								lineHeight: '150%',
								fontFamily: 'Poppins',
								py: '8px',
							},
						}}
					>
						<TableCell>Name</TableCell>
						<TableCell>Email / Phone</TableCell>
						<TableCell>TimeZone</TableCell>
						<TableCell>Scheduled Time</TableCell>
						<TableCell>Call Time</TableCell>
						<TableCell>Duration</TableCell>
						<TableCell>History</TableCell>
						{/* <TableCell /> */}
						<TableCell>Reschedule</TableCell>
						<TableCell>Status</TableCell>
					</TableHead>

					<TableBody sx={{ '& .MuiTableCell-root': { py: '8px' } }}>
						{filteredUsers?.map((i, index) => {
							// {console.log(`i - ${index}`, i);}
							return (
								<TableRow sx={{ '& .MuiTableCell-root': { verticalAlign: 'center' } }} key={index}>
									<TableCell>
										<UserThumbnail user={!i?.anonymous ? i?.userId : null} userId={!i?.anonymous ? i?.userId?._id : null} />
									</TableCell>
									<TableCell>
										<Typography
											sx={{
												fontSize: '12px',
												lineHeight: '115%',
												fontFamily: 'Poppins',
												color: AppColors.TEXT_PRIMARY,
												fontWeight: 400,
												mb: 1,
											}}
										>
											{i?.userId?.phoneNumber}
										</Typography>
										<Typography
											sx={{
												fontSize: '12px',
												lineHeight: '115%',
												fontFamily: 'Poppins',
												color: AppColors.TEXT_PRIMARY,
												fontWeight: 400,
											}}
										>
											{i?.userId?.email}
										</Typography>
									</TableCell>

									<TableCell>
										<Typography
											sx={{
												fontSize: '12px',
												lineHeight: '115%',
												fontFamily: 'Poppins',
												color: AppColors.TEXT_PRIMARY,
												fontWeight: 400,
											}}
										>
											{i?.userId?.timezone}
										</Typography>
									</TableCell>
									<TableCell sx={{ minWidth: '320px' }}>
										<Stack direction="row" alignItems="center" gap={0.5}>
											<Typography
												sx={{
													fontSize: '12px',
													fontFamily: 'Poppins',
													color: AppColors.TEXT_PRIMARY,
													fontWeight: 400,
												}}
											>
												{/* {i?.startDateTime && moment(i?.startDateTime).tz(i?.userId?.timezone).format('lll')}{' '} */}
												{i?.callHistory?.length !== 0 ? (
													<Box gap={1} sx={{}}>
														{/* Show the first history item */}

														{i?.callHistory.slice(0, 2).map((history, index) => (
															<HistoryItem key={index} history={history} details={i} />
														))}

														{/* Show "More Info" if there are additional items */}
														{i?.callHistory?.length > 2 && (
															<Tooltip
																slotProps={{
																	tooltip: {
																		sx: (theme) => ({
																			bgcolor: AppColors.WHITE,
																			color: AppColors.DARK_GREY,
																			boxShadow: '0 0 4 0 #B9B9F780',
																			radius: '5px',
																			border: `1px solid ${theme.palette.primary.lightest_shade}`,
																		}),
																	},
																	arrow: {
																		sx: (theme) => ({
																			color: AppColors.WHITE, // Arrow color matches tooltip background
																			'&::before': {
																				border: `1px solid ${theme.palette.primary.lightest_shade}`, // Arrow border
																			},
																		}),
																	},
																}}
																arrow
																title={
																	<Stack gap={1}>
																		{i?.callHistory.slice(2).map((history, index) => (
																			<HistoryItem key={index + 2} history={history} details={i} />
																		))}
																	</Stack>
																}
																placement="left"
															>
																<Typography
																	sx={(theme) => ({
																		fontSize: '12px',
																		lineHeight: '115%',
																		fontFamily: 'Poppins',
																		color: theme.palette.primary.darker_primary,
																		marginLeft: 'auto',
																		fontWeight: 600,
																		cursor: 'pointer',
																	})}
																>
																	More Info
																</Typography>
															</Tooltip>
														)}
													</Box> 
												) : ( i?.startDateTime &&  moment(i?.startDateTime).tz(i?.userId?.timezone).format('lll')) }
											</Typography>
										</Stack>
									</TableCell>
									<TableCell sx={{ minWidth: '120px' }}>
										<Typography
											sx={{
												fontSize: '12px',
												lineHeight: '115%',
												letterSpacing: '0',
												color: AppColors.TEXT_PRIMARY,
												fontWeight: 400,
											}}
										>
											{i?.call?.createdAt && moment(i?.call?.createdAt).tz(i?.userId?.timezone).format('lll')}
										</Typography>
									</TableCell>

									<TableCell sx={{ minWidth: '120px' }}>
										<Typography
											sx={{
												fontSize: '12px',
												lineHeight: '115%',
												letterSpacing: '0',
												color: AppColors.TEXT_PRIMARY,
												fontWeight: 400,
											}}
										>
											{i?.call?.startedAt && i?.call?.endedAt && formatDuration(i.call.startedAt, i.call.endedAt)}
										</Typography>
									</TableCell>

									{/* <TableCell>
										
									</TableCell> */}
									<TableCell />

									<TableCell>
										<Stack direction="row" alignItems="center" justifyContent="center" gap={0.5}>
											{!i?.call && !i?.startDateTime && (
												<Tooltip
													title="ReSchedule"
													arrow
													onClick={() => {
														window.open(`${window.location.origin}/campaign-scheduling?id=${i?._id}`, '_blank');
													}}
												>
													<Stack className="cursor-pointer">
														<IosLink color="blue" />
													</Stack>
												</Tooltip>
											)}
										</Stack>
									</TableCell>

									<TableCell>
										{i?.call?.status && (
											<CustomTag
												tagTitle={
													<Stack direction="row" alignItems="center" gap={0.5}>
														<Typography
															sx={(theme) => ({
																fontSize: '12px',
																lineHeight: '115%',
																fontFamily: 'Poppins',
																color: theme.palette.primary.darker_primary,
																fontWeight: 400,
																letterSpacing: '0',
																textTransform: 'capitalize',
															})}
														>
															{i?.call?.status}
														</Typography>
														{i?.call?.endedReason && (
															// <Tooltip title={i?.call?.endedReason?.replaceAll('-', ' ')}>
															// 	<Stack>
															// 		<InfoIcon color={AppColors.DARKER_PRIMARY} />
															// 	</Stack>
															// </Tooltip>
															<CustomInfoTooltip
																title={i?.call?.endedReason?.replaceAll('-', ' ')}
																iconSize={16}
																placement="bottom"
															/>
														)}
													</Stack>
												}
											/>
										)}
									</TableCell>
								</TableRow>
							);
						})}
						<TableRow
							sx={{
								position: 'sticky',
								bottom: '0',
								// right: '10px',
								backgroundColor: AppColors.WHITE,
								zIndex: 2, // Ensure it's above other rows
								// width:'10%'
							}}
						>
							<TableCell colSpan={12} align="center">
								<CustomTablePagination
									{...pagination}
									onChange={(p, r) => getList(p, r)}
									onRowsPerPageChange={(e) => getList(1, e.target.value)}
								/>
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			)}
		</TableContainer>
	);
}
